!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.AutosuggestHighlightParse = e() : t.AutosuggestHighlightParse = e();
}(this, function () {
  return t = {
    705: function _(t) {
      t.exports = function (t, e) {
        var h = [];
        return 0 === e.length ? h.push({
          text: t,
          highlight: !1
        }) : e[0][0] > 0 && h.push({
          text: t.slice(0, e[0][0]),
          highlight: !1
        }), e.forEach(function (i, o) {
          var s = i[0],
            r = i[1];
          h.push({
            text: t.slice(s, r),
            highlight: !0
          }), o === e.length - 1 ? r < t.length && h.push({
            text: t.slice(r, t.length),
            highlight: !1
          }) : r < e[o + 1][0] && h.push({
            text: t.slice(r, e[o + 1][0]),
            highlight: !1
          });
        }), h;
      };
    }
  }, e = {}, function h(i) {
    var o = e[i];
    if (void 0 !== o) return o.exports;
    var s = e[i] = {
      exports: {}
    };
    return t[i](s, s.exports, h), s.exports;
  }(705);
  var t, e;
});